import type { AssetEvent } from "@/entities/asset-event";

import { getModelKey } from "@/modules/model";

// TODO DEV-8365 delete helper when class path will be replaced by model slug
export const getAssetEventCauserModel = (assetEvent?: AssetEvent) => {
  return getModelKey(assetEvent?.causer_type ?? undefined);
};
